import React, {Component} from 'react'
import {connect} from 'react-redux'
import { Menu, Segment } from 'semantic-ui-react'
import Icons from "../../Constants/Icons";
import RequestURLBox from "../../SharedComponents/RequestURLBox"
import {getFullAPIUrl} from "../getFullAPIUrl";
import CustomAccordion from "../../SharedComponents/CustomAccordion"
import UtilitiesCodeAccordion from "../UtilitiesCodeAccordion"
import UtilitiesCodeSnippet from "../UtilitiesCodeSnippet"
import UtilitiesSampleResponse from "../UtilitiesSampleResponse"
import JSONAccordionIndex from "../../SharedComponents/JSONAccordion/JSONAccordionIndex"
import FilesResponseParams from "../FilesResponseParams"
import ErrorResponseCodesBody from "../ErrorResponseCodesBody"

class UtilitiesFileReadIndex extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            fileId: '',
            actualResponse: null,
            loadingResponse: false,
            responseError: null,
            includeSamples: false,
            sampleRows: 5
        }
    }

    componentDidMount() {
    }

    fetchActualResponse = async () => {
        if (!this.state.fileId.trim()) {
            this.setState({ 
                responseError: 'Please enter a file ID', 
                loadingResponse: false 
            });
            return;
        }

        this.setState({ loadingResponse: true, responseError: null });
        
        try {
            const { utilitiesInfo } = this.props;
            let url = getFullAPIUrl(this.props.baseURL, "files") + `/${this.state.fileId}`;
            
            // Add query parameters if includeSamples is true
            if (this.state.includeSamples) {
                const params = new URLSearchParams();
                params.append('includeSamples', 'true');
                params.append('sampleRows', this.state.sampleRows.toString());
                url += `?${params.toString()}`;
            }
            
            const headers = {};
            if (utilitiesInfo && utilitiesInfo.keys && utilitiesInfo.keys.length > 0) {
                headers['accessKey'] = utilitiesInfo.keys[0].access_key;
                headers['secretKey'] = utilitiesInfo.keys[0].secret_key;
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: headers
            });

            if (response.ok) {
                const data = await response.json();
                this.setState({ actualResponse: data, loadingResponse: false });
            } else {
                const errorData = await response.json();
                this.setState({ 
                    responseError: errorData.error || 'Failed to fetch response', 
                    loadingResponse: false 
                });
            }
        } catch (error) {
            this.setState({ 
                responseError: 'Network error: ' + error.message, 
                loadingResponse: false 
            });
        }
    }

    handleFileIdChange = (value) => {
        this.setState({ fileId: value });
    }

    handleIncludeSamplesChange = (value) => {
        this.setState({ includeSamples: value });
    }

    handleSampleRowsChange = (value) => {
        this.setState({ sampleRows: parseInt(value) || 5 });
    }

    getFullUrl = () => {
        const baseUrl = getFullAPIUrl(this.props.baseURL, "files");
        let url = this.state.fileId ? `${baseUrl}/${this.state.fileId}` : `${baseUrl}/{file_id}`;
        
        // Add query parameters if includeSamples is true
        if (this.state.includeSamples) {
            const params = new URLSearchParams();
            params.append('includeSamples', 'true');
            params.append('sampleRows', this.state.sampleRows.toString());
            url += `?${params.toString()}`;
        }
        
        return url;
    }

    getCodeSamples = () => {
        const url = this.getFullUrl();
        const { utilitiesInfo } = this.props;
        
        const hasAuth = utilitiesInfo && utilitiesInfo.keys && utilitiesInfo.keys.length > 0;
        const accessKey = hasAuth ? utilitiesInfo.keys[0].access_key : '<your-access-key>';
        const secretKey = hasAuth ? utilitiesInfo.keys[0].secret_key : '<your-secret-key>';

        return {
            cURL: hasAuth 
                ? `$ curl -X GET '${url}' \\\n-H "accessKey: ${accessKey}" \\\n-H "secretKey: ${secretKey}"`
                : `$ curl -X GET '${url}'`,
            python: hasAuth
                ? `# pip install requests\n\nimport requests\n\nheaders = {\n    "accessKey": "${accessKey}",\n    "secretKey": "${secretKey}"\n}\n\nr = requests.get("${url}", headers=headers)\n\nif r.status_code == 200:\n    # SUCCESS\n    resp_data = r.json()\nelse:\n    # ERROR\n    pass`
                : `# pip install requests\n\nimport requests\n\nr = requests.get("${url}")\n\nif r.status_code == 200:\n    # SUCCESS\n    resp_data = r.json()\nelse:\n    # ERROR\n    pass`,
            javascript: hasAuth
                ? `fetch("${url}", {\n    method: "GET",\n    headers: {\n        "Accept": "application/json, text/plain, */*",\n        "accessKey": "${accessKey}",\n        "secretKey": "${secretKey}"\n    }\n}).then(res => {\n    if (res.status === 200) {\n        res.json().then(data => {\n            // SUCCESS\n            const respData = data;\n        }).catch(err => console.log(err))\n    } else {\n        // ERROR\n    }\n})`
                : `fetch("${url}", {\n    method: "GET",\n    headers: {\n        "Accept": "application/json, text/plain, */*"\n    }\n}).then(res => {\n    if (res.status === 200) {\n        res.json().then(data => {\n            // SUCCESS\n            const respData = data;\n        }).catch(err => console.log(err))\n    } else {\n        // ERROR\n    }\n})`,
            ruby: hasAuth
                ? `require 'net/http'\nrequire 'json'\n\nurl = "${url}"\nuri = URI.parse(url)\n\nhttp = Net::HTTP.new(uri.host, uri.port)\nrequest = Net::HTTP::Get.new(uri.request_uri)\nrequest['accessKey'] = '${accessKey}'\nrequest['secretKey'] = '${secretKey}'\n\nresponse = http.request(request)\nif response.code == '200'\n    # SUCCESS\n    resp_data = JSON.parse(response.body)\nelse\n    # ERROR\nend`
                : `require 'net/http'\nrequire 'json'\n\nurl = "${url}"\nuri = URI.parse(url)\n\nhttp = Net::HTTP.new(uri.host, uri.port)\nrequest = Net::HTTP::Get.new(uri.request_uri)\n\nresponse = http.request(request)\nif response.code == '200'\n    # SUCCESS\n    resp_data = JSON.parse(response.body)\nelse\n    # ERROR\nend`,
            PHP: hasAuth
                ? `<?php\n$url = "${url}";\n\n$curl = curl_init($url);\ncurl_setopt($curl, CURLOPT_HEADER, false);\ncurl_setopt($curl, CURLOPT_RETURNTRANSFER, true);\ncurl_setopt($curl, CURLOPT_HTTPHEADER, array(\n    "accessKey: ${accessKey}",\n    "secretKey: ${secretKey}"\n));\ncurl_setopt($curl, CURLOPT_HTTPGET, true);\n\n$json_response = curl_exec($curl);\n\n$status = curl_getinfo($curl, CURLINFO_HTTP_CODE);\n\nif ($status == 200)\n    // SUCCESS\n    $resp_data = json_decode($json_response, true);\n} else {\n    // ERROR\n}\n\ncurl_close($curl);\n?>`
                : `<?php\n$url = "${url}";\n\n$curl = curl_init($url);\ncurl_setopt($curl, CURLOPT_HEADER, false);\ncurl_setopt($curl, CURLOPT_RETURNTRANSFER, true);\ncurl_setopt($curl, CURLOPT_HTTPGET, true);\n\n$json_response = curl_exec($curl);\n\n$status = curl_getinfo($curl, CURLINFO_HTTP_CODE);\n\nif ($status == 200)\n    // SUCCESS\n    $resp_data = json_decode($json_response, true);\n} else {\n    // ERROR\n}\n\ncurl_close($curl);\n?>`
        };
    }

    render() {
        const { fileId, actualResponse, loadingResponse, responseError, includeSamples, sampleRows } = this.state;
        const fullUrl = this.getFullUrl();

        return (
            <div>
                <div style={{ marginBottom: "24px"}}>
                    <RequestURLBox url={fullUrl} />
                </div>

                <div style={{ marginBottom: "24px"}}>
                    <CustomAccordion
                        body={
                            <div style={{ padding: "16px" }}>
                                <div style={{ marginBottom: "20px" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
                                        <div style={{ flex: 1 }}>
                                            <h4 style={{ margin: "0 0 4px 0", fontSize: "14px", fontWeight: "600", color: "#333" }}>
                                                file_id
                                            </h4>
                                            <p style={{ margin: "0 0 4px 0", fontSize: "12px", color: "#666" }}>
                                                <strong>Type:</strong> string | <strong>Required:</strong> Yes
                                            </p>
                                            <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#666" }}>
                                                The unique identifier (hash) of the file to retrieve.
                                            </p>
                                        </div>
                                        <input
                                            type="text"
                                            value={fileId}
                                            onChange={(e) => this.handleFileIdChange(e.target.value)}
                                            placeholder="Enter file ID..."
                                            style={{
                                                width: "200px",
                                                padding: "6px 8px",
                                                border: "1px solid #ddd",
                                                borderRadius: "4px",
                                                fontSize: "12px"
                                            }}
                                        />
                                    </div>
                                </div>

                                <div style={{ marginTop: "20px", textAlign: "center" }}>
                                    <button
                                        onClick={this.fetchActualResponse}
                                        disabled={!fileId.trim() || loadingResponse}
                                        style={{
                                            padding: "8px 16px",
                                            backgroundColor: fileId.trim() && !loadingResponse ? "#007bff" : "#6c757d",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "4px",
                                            cursor: fileId.trim() && !loadingResponse ? "pointer" : "not-allowed",
                                            fontSize: "12px"
                                        }}
                                    >
                                        {loadingResponse ? "Loading..." : "Test Request"}
                                    </button>
                                </div>
                            </div>
                        }
                        header="File ID Parameter"
                        accordionStyle={{
                            borderRadius: '4px',
                            border: "1px solid #F0F0F0",
                            backgroundColor: 'white'
                        }}
                        headerDivStyle={{
                            borderRadius: '4px',
                            backgroundColor: 'white',
                            fontSize: '16px',
                            fontWeight: '700',
                            fontFamily: "Lato",
                            padding: "16px"
                        }}
                    />
                </div>

                <div style={{ marginBottom: "24px"}}>
                    <CustomAccordion
                        body={
                            <div style={{ padding: "16px" }}>
                                <div style={{ marginBottom: "20px" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
                                        <div style={{ flex: 1 }}>
                                            <h4 style={{ margin: "0 0 4px 0", fontSize: "14px", fontWeight: "600", color: "#333" }}>
                                                includeSamples
                                            </h4>
                                            <p style={{ margin: "0 0 4px 0", fontSize: "12px", color: "#666" }}>
                                                <strong>Type:</strong> boolean | <strong>Required:</strong> No | <strong>Default:</strong> false
                                            </p>
                                            <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#666" }}>
                                                When true, includes sample data in the response. When false, sample data is not included.
                                            </p>
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <input
                                                type="checkbox"
                                                checked={includeSamples}
                                                onChange={(e) => this.handleIncludeSamplesChange(e.target.checked)}
                                                style={{
                                                    marginRight: "8px",
                                                    transform: "scale(1.2)"
                                                }}
                                            />
                                            <span style={{ fontSize: "12px", color: "#666" }}>
                                                {includeSamples ? "true" : "false"}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {includeSamples && (
                                    <div style={{ marginBottom: "20px" }}>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
                                            <div style={{ flex: 1 }}>
                                                <h4 style={{ margin: "0 0 4px 0", fontSize: "14px", fontWeight: "600", color: "#333" }}>
                                                    sampleRows
                                                </h4>
                                                <p style={{ margin: "0 0 4px 0", fontSize: "12px", color: "#666" }}>
                                                    <strong>Type:</strong> integer | <strong>Required:</strong> No | <strong>Default:</strong> 5 | <strong>Range:</strong> 1-100
                                                </p>
                                                <p style={{ margin: "0 0 8px 0", fontSize: "12px", color: "#666" }}>
                                                    Number of sample rows to return when includeSamples is true.
                                                </p>
                                            </div>
                                            <input
                                                type="number"
                                                value={sampleRows}
                                                onChange={(e) => this.handleSampleRowsChange(e.target.value)}
                                                min="1"
                                                max="100"
                                                style={{
                                                    width: "80px",
                                                    padding: "6px 8px",
                                                    border: "1px solid #ddd",
                                                    borderRadius: "4px",
                                                    fontSize: "12px"
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        }
                        header="Query Parameters"
                        accordionStyle={{
                            borderRadius: '4px',
                            border: "1px solid #F0F0F0",
                            backgroundColor: 'white'
                        }}
                        headerDivStyle={{
                            borderRadius: '4px',
                            backgroundColor: 'white',
                            fontSize: '16px',
                            fontWeight: '700',
                            fontFamily: "Lato",
                            padding: "16px"
                        }}
                    />
                </div>

                <div style={{ marginBottom: "24px"}}>
                    <CustomAccordion
                        body={
                            <div>
                                <UtilitiesCodeSnippet code={this.getCodeSamples()} height={150} />
                            </div>
                        }
                        header="Code Samples"
                        accordionStyle={{
                            borderRadius: '4px',
                            border: "1px solid #F0F0F0",
                            backgroundColor: 'white'
                        }}
                        headerDivStyle={{
                            borderRadius: '4px',
                            backgroundColor: 'white',
                            fontSize: '16px',
                            fontWeight: '700',
                            fontFamily: "Lato",
                            padding: "16px"
                        }}
                        open
                    />
                </div>

                <div style={{ marginBottom: "24px"}}>
                    <div className="row">
                        <div className="col-sm-6">
                            <JSONAccordionIndex
                                title="Sample Response Body"
                                message=""
                                heading=""
                                jsonObj={actualResponse || {}}
                            />
                        </div>
                        <div className="col-sm-6">
                            <CustomAccordion
                                body={<div>
                                    {loadingResponse ? (
                                        <div style={{ padding: "20px", textAlign: "center" }}>
                                            <div>Loading actual response...</div>
                                        </div>
                                    ) : responseError ? (
                                        <div style={{ padding: "20px", color: "#dc3545" }}>
                                            <div><strong>Error:</strong> {responseError}</div>
                                            <button 
                                                onClick={this.fetchActualResponse}
                                                style={{
                                                    marginTop: "10px",
                                                    padding: "8px 16px",
                                                    backgroundColor: "#007bff",
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: "4px",
                                                    cursor: "pointer"
                                                }}
                                            >
                                                Retry
                                            </button>
                                        </div>
                                    ) : (
                                        <div style={{ fontSize: "14px", color: "#666", marginBottom: "24px" }}>
                                            A successful request will return a <code style={{ color: "#333", fontWeight: "700"}}>200 response code</code> and the following parameters
                                        </div>
                                    )}
                                    <FilesResponseParams />
                                </div>}
                                header="Response Body Parameters"
                                accordionStyle={{
                                    borderRadius: '4px',
                                    border: "1px solid #F0F0F0",
                                    backgroundColor: 'white'
                                }}
                                headerDivStyle={{
                                    borderRadius: '4px',
                                    backgroundColor: 'white',
                                    fontSize: '16px',
                                    fontWeight: '700',
                                    fontFamily: "Lato",
                                    padding: "16px"
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div style={{ marginTop: "24px"}}>
                    <CustomAccordion
                        body={<ErrorResponseCodesBody
                            mode="files"
                        />}
                        header="Error Response Codes and Messages"
                        accordionStyle={{
                            borderRadius: '4px',
                            border: "1px solid #F0F0F0",
                            backgroundColor: 'white'
                        }}
                        headerDivStyle={{
                            borderRadius: '4px',
                            backgroundColor: 'white',
                            fontSize: '16px',
                            fontWeight: '700',
                            fontFamily: "Lato",
                            padding: "16px"
                        }}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    utilitiesInfo: state.mainState.utilitiesInfo
})

const mapActionsToProps = {}

export default connect(mapStateToProps, mapActionsToProps)(UtilitiesFileReadIndex)
